import React from "react";
import "./Analytics.css";

// Auto-compact number formatting for stat-tile values: 1,284 / 12.9K / $4.2M
export const formatCompact = (value, { currency = false } = {}) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
  const num = Number(value);
  const prefix = currency ? "$" : "";
  const abs = Math.abs(num);

  if (abs >= 1_000_000) return `${prefix}${(num / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${prefix}${(num / 1_000).toFixed(1)}K`;
  if (currency) return `${prefix}${num.toFixed(2)}`;
  return `${prefix}${num.toLocaleString()}`;
};

// Exact (non-abbreviated) integer formatting for counts where precision matters more than compactness.
export const formatCount = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
  return Number(value).toLocaleString();
};

const StatTile = ({ label, value, subValue, status }) => (
  <div className={`stat-tile${status ? ` stat-tile-${status}` : ""}`}>
    <span className="stat-tile-label">{label}</span>
    <span className="stat-tile-value">{value}</span>
    {subValue && <span className="stat-tile-subvalue">{subValue}</span>}
  </div>
);

export default StatTile;
